module.exports = __webpack_public_path__ + "static/img/HRM_logo_2021_NT_2048x2048.14bd00c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/HRM_logo_2021_NT_2048x2048.png
// module id = VgV5
// module chunks = 1